export default __webpack_public_path__ + "static/media/Republic5.3b3bf21e.png";